<template lang="jade">
  .container-fluid
    .row
      .status_main.col-md-12
        header.config_title_bar.main_title_bar.clearfix
          h1.title.col-md-2.col-lg-2.col-sm-2.col-xs-3.clearfix
            | Status
            //- for viewport debug
          v-loader.col-lg-2.col-lg-offset-3.col-md-2.col-md-offset-3.col-sm-1.col-sm-offset-3.col-xs-2.col-xs-offset-0(
            v-bind:ani-key="'6'"
            v-if="isFetching"
          )
          .window_setting.col-lg-2.col-md-2.col-xs-2.row_space--xxs.pull-right
            i.fa.fa-cog.fa-2x(v-on:click='handleshowOutSetting()')
        section.status_content
          section.screen_block.clearfix.col-md-12.col-lg-12.no_pad
            section.screen_section.col-xs-12.col-sm-7.col-md-7.col-lg-8.row_space--sm.no_pad.clearfix
              v-screen(
                v-bind:editable='true'
                v-bind:show-link='true'
                v-bind:in-which-page="'status'"
                v-bind:show-ps-out="true"
                v-bind:show-ps-in="true"
              )
            section.function_section.col-xs-12.col-sm-5.col-md-5.col-lg-4.clearfix.no_pad-xxs
              .col-xs-12.col-md-12.full_screen_btn_group.col-centered.clearfix.no_pad-xxs
                header.row_space--xxs.hidden-xs
                  label Output
                .col-xs-3.col-sm-3.col-md-3.full__btn__single.clearfix(v-for='key in outputPorts')
                  button.btn.btn-default.clearfix.btn-square-xs(
                    v-on:click="toFocus(key)"
                    v-bind:disabled="buttonDisabled"
                    v-bind:class="{active: windowFocus === key}")
                    | {{key}}
              .col-xs-12.col-md-12.quick_selection_btn_group.col-centered.clearfix.no_pad-xxs
                header.row_space--xxs.hidden-xs
                  label Quick Selection
                .quick__btn__single.pull-left(v-for='(key, val) in outSplitOptions' v-if="!isFetching")
                  button.btn.btn-default.clearfix.btn-square-xs(
                    v-on:click="sendKeyToDevice(key)"
                    v-bind:disabled="is4K || buttonDisabled"
                    v-bind:class="{straight: isStraight(key)}")
                    img.icon(v-bind:src='quickIcons[key-1]')
                //- .quick__btn__single.pull-left(v-for='(key, opt) in quickSelectionOptions' )
                //-   button.btn.btn-default.col-xs-12.pull-left.clearfix.btn-square-xs(v-on:click="changeProps('quick', opt.value, opt.splitOptionKey)")
                //-     img.icon(v-bind:src='icons.quick[key]')
              .col-xs-12.col-md-12.custom_btn_group.col-centered.clearfix
                header.row_space--xxs.hidden-xs
                  label Custom Preset
                .custom__btn__single.col-xs-3.col-sm-3.col-md-3.clearfix(v-for='key in profileOptions' )
                  button.btn.btn-default.btn-square-xs.no_pad(v-on:click="setLayoutByProfileKey(key)" v-bind:disabled="buttonDisabled")
                    span
                      i.fa.fa-user
                        |&nbsp;{{key}}
                    br
                    span.profile_name {{customProfileOptions[key].name}}
      modal(title='Settings'
            v-bind:show.sync='showOutSetting'
            effect='fade'
            ok-text='Apply'
            cancel-text='Cancel'
            backdrop='false').window_setting_modal
        .modal-header(slot='modal-header')
          button.close(v-on:click='showOutSetting = false' v-bind:disabled.sync='isUpdatingProfile')
            span &times;
          h4.modal-title Settings
        .modal-body.clearfix(slot='modal-body')
          tabs
            tab(header='Output')
              section.resolution_sec.clearfix.col-md-12.outer_group
                .col-md-12
                  h3.title Output Setting
                .col-xs-12.col-sm-12.clearfix.row_space--xs(v-for="(key, val) in editing.outResolutions")
                  label.col-xs-4.no_pad Output {{key}} Resolution:
                  v-select(v-bind:options='computedOutResolutionOptions' v-bind:value.sync='val')
                  button.btn.btn-primary.pull-right(v-on:click='applyOutputResolution(key)') Apply
            tab(header='Input' v-if="model === 'VW-1404ZH-G' || isVDev")
              section.clearfix.col-md-12.outer_group
                .col-md-12
                  h3.title Input Source
                .col-xs-12.col-sm-12.clearfix.row_space--xs
                  label.col-xs-4.no_pad From HDMI
                  label.iosCheck
                    //- .mask(v-on:click.stop="switchSource()")
                    input(type='checkbox' v-model="editingSourceFrom")
                    i
                .col-xs-12.col-ms-12
                  button.pull-right.btn.btn-primary(v-on:click="applySourcInput()") Apply
        .modal-footer.clearfix(slot='modal-footer')
          button.btn.btn-default(v-on:click="showOutSetting = false" v-bind:disabled.sync='isUpdatingProfile') Cancel
</template>
<script>
import Screen from 'src/components/VWScreen.vue'
import Loader from '../../components/Loader.vue'
import { modal, tab } from 'vue-strap'
import tabset from 'src/components/Tabset.vue'
import { call } from '../../Service'
import singleSelect from 'src/components/Single-Select.vue'
import _ from 'lodash'

import { mapGetters } from 'vuex'

export default {
  components: {
    modal,
    tabs: tabset,
    tab,
    'v-screen': Screen,
    'v-select': singleSelect,
    'v-loader': Loader
  },
  data () {
    return {
      showOutSetting: false,
      ww: 0,
      quickIcons: [
        require('src/assets/img/icon/splitters/38-01.png'),
        require('src/assets/img/icon/splitters/39-01.png'),
        require('src/assets/img/icon/splitters/41-01.png'),
        require('src/assets/img/icon/splitters/40-01.png'),
        require('src/assets/img/icon/splitters/33-01.png'),
        require('src/assets/img/icon/splitters/34-01.png'),
        require('src/assets/img/icon/splitters/35-01.png'),
        require('src/assets/img/icon/splitters/36-01.png')
      ],
      editing: {
        outResolutions: []
      },
      buttonDisabled: false,
      editingSourceFrom: false
    }
  },
  async asyncData () {
    let { mac } = this.$route.params
    await this.$store.dispatch('fetchData', mac)
    console.log('done async')
  },
  computed: {
    ...mapGetters({
      isFetching: 'getIsFetching',
      is4K: 'getIsInput4k',
      inRatio: 'getInRatio',
      splits: 'getSplitArea',
      outputPorts: 'getOutputPorts',
      windowFocus: 'getWindowFocus',
      focus1: 'isFocus1',
      focus2: 'isFocus2',
      focus3: 'isFocus3',
      focus4: 'isFocus4',
      outSplitOptions: 'getOutputSplitOptions',
      customProfileOptions: 'getProfiles',
      outResolutionOpts: 'getOutResolutionOptions',
      outResolutions: 'getOutResolutions',
      canSetRotatedSplit: 'getCanSetRotatedSplit',
      inResolution: 'getInResolution',
      model: 'getDeviceModel',
      isSourceFromHDMI: 'getIsSourceFromHDMI'
    }),
    profileOptions () {
      return Object.keys(this.customProfileOptions)
    },
    isVDev () {
      return this.$route.params.mac.startsWith('00:00:00:00')
    },
    computedOutResolutionOptions () {
      return Object.keys(this.outResolutionOpts).map((k) => {
        return {
          label: this.outResolutionOpts[k],
          value: parseInt(k)
        }
      })
    }
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    applySourcInput () {
      let { mac } = this.$route.params
      call(mac, 'dxSetInputSource', {
        isSourceFromHDMI: this.editingSourceFrom
      }).then(res => {
        this.showOutSetting = false
        this.$store.dispatch('fetchSource', {mac, model: this.model})
      }).catch(e => {
        console.error(e)
      })
    },
    sendKeyToDevice (option) {
      if (!this.canSetRotatedSplit && parseInt(option) < 5) {
        this.$dispatch('alert', {
          type: 'warning',
          title: '',
          content: 'Outputs and input needs to be all 1920x1080 to rotate the output.'
        })
        return
      }
      this.buttonDisabled = true
      let { mac } = this.$route.params
      call(mac, 'dxSetSplitByOption', {
        option
      }).then(res => {
        console.log('call splitArea done', res)
      }).catch(err => {
        console.error(err)
      })
    },
    handleshowOutSetting () {
      this.showOutSetting = true
      this.editing.outResolutions = _.cloneDeep(this.outResolutions)
      this.editingSourceFrom = _.cloneDeep(this.isSourceFromHDMI)
    },
    applyOutputResolution (key) {
      let resolution = {}
      // for (let key in this.editing.outResolutions) {
      //   if (this.editing.outResolutions[key] !== this.outResolutions[key]) {
      //     resolution[key] = this.editing.outResolutions[key]
      //   }
      // }
      resolution[key] = this.editing.outResolutions[key]
      call(this.$route.params.mac, 'dxSetOutputResolution', {resolution}).then(res => {
        console.log(res) // let event system do the rest
      }).catch(err => {
        console.error(err)
      })
    },
    isStraight (key) {
      return parseInt(key) < 5
    },
    addListener () {
      this.$store.dispatch('updateMainScreenSize')
      this.$broadcast('render', '1')
    },
    toFocus (windowFocus) {
      this.$store.commit('UPDATE', {type: 'winFocus', windowFocus})
    },
    setLayoutByProfileKey (profile) {
      if (this.inResolution['1'] !== this.customProfileOptions[profile].resolution) {
        this.alert('warning', '', 'Profile resolution does not match the input resolution')
        return
      }
      let mac = this.$route.params.mac
      call(mac, 'dxSetDeviceByProfileKey', {
        profile
      }).then(res => {
        console.log(res)
      })
    },
    setSplitByOption (option) {
      // dxSetSplitByOption
    }
  }, // close methods
  ready () {
    window.addEventListener('orientationchange', this.addListener, false)
    window.addEventListener('resize', this.addListener, false)
  },
  beforeDestroy () {
    window.removeEventListener('orientationchange', this.addListener, false)
    window.removeEventListener('resize', this.addListener, false)
  },
  watch: {
    isFetching (nv) {
      // do not render until fetchin is done
      if (!nv) this.addListener()
    },
    is4K (nv) {
    }
  },
  route: { // add these code to index of every type of devices to reload data
    canReuse: false, // can't reuse so forces it to reload data
    activate ({next}) {
      next()
    }
  },
  events: {
    update (mac, {type, event, msg}) {
      switch (type) {
        case 'split':
          this.outLayout = 'init'
          this.$store.commit('UPDATE', {
            type: 'split',
            splitArea: {
              split: event
            }
          })

          setTimeout(() => {
            this.addListener()
            this.buttonDisabled = false
          }, 700)
          break
        case 'resolution':
          this.buttonDisabled = true
          // this.outResolution = event['1']
          if (event.input) {
            this.$store.commit('UPDATE', {type: 'inResolution', resolution: event.input})
            this.$store.commit('UPDATE', {type: 'inRatio'})
            this.addListener()
          }

          if (event.output) {
            this.$store.commit('UPDATE', {
              type: 'outResolutions',
              resolution: event.output
            })
          }

          setTimeout(() => {
            this.buttonDisabled = false
          }, 700)
          break
        case 'preset':
          this.$store.commit('UPDATE', {
            type: 'preset',
            preset: event
          })
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';

.config_title_bar{
  & h1.title{
    @include breakpoint(xs) {
      & span::after{
        content: 'xs';
        display: block;
      }
    }
    @include breakpoint(sm) {
      & span::after{
        content: 'sm';
        display: block;
      }
    }
    @include breakpoint(md) {
      & span::after{
        content: 'md';
        display: block;
      }
    }
    @include breakpoint(lg) {
      & span::after{
        content: 'lg';
        display: block;
      }
    }
  }
}

.function_section{
  margin-top: $space_xxs;
  padding-top: $space_xxs;
  @include breakpoint(xs){
    border-top: 1px solid $pri_gray;
    margin-top: 0;
    padding-top: 0;
  }
  @include breakpoint(landXS) {
    border-top: 1px solid $pri_gray;
  }
}

.window_setting{
  & .btn{
    margin-left: auto;
    margin-right: auto;
  }
  text-align: center;
  position:fixed;
  z-index:50;
  right:15px;
  top:40px;
  @include breakpoint(xs) {
    top: 38px;
  }
}

.full_screen_btn_group{
  & .full__btn__single{
    & .btn {
      color: $base_black;
      font-weight: bold;
      font-size: 18px;
    }
    &:nth-of-type(1){
      .btn {
        background-color: $window_a;
        &.active {
          background-color: darken($window_a, 10%);
          color: $base_white;
        }
      }

    }
    &:nth-of-type(2){
      .btn {
        background-color: $window_b;
        &.active {
          background-color: darken($window_b, 10%);
          color: $base_white;
        }
      }
    }
    &:nth-of-type(3){
      .btn {
        background-color: $window_c;
        &.active {
          background-color: darken($window_c, 10%);
          color: $base_white;
        }
      }
    }
    &:nth-of-type(4){
      .btn {
        background-color: $window_d;
        &.active {
          background-color: darken($window_d, 10%);
          color: $base_white;
        }
      }
    }
  }
}

.quick__btn__single{
  width: 25%;
  padding: $space_xxs;
  @include breakpoint(sm) {
    width: 25%;
  }
  .btn{
    padding: 10px;
  }
  .btn.straight {
    padding-top: 5px;
    padding-bottom: 3px;
  }
  .straight img {
    width: auto;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
}

.custom__btn__single{
  margin-bottom: $space_xxs;
  .profile_name{
    font-size: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// Status.vue?b5cc0fb0